
import React, { useEffect } from 'react';
import { useToast } from "@/hooks/use-toast";

interface AboutMeAutoSaveProps {
  activeSection: string;
}

const AboutMeAutoSave: React.FC<AboutMeAutoSaveProps> = ({ activeSection }) => {
  const { toast } = useToast();

  // Auto-save on visibility change
  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.visibilityState === 'hidden') {
        console.log('About Me: Saving form state on tab visibility change');
        // Don't submit, just ensure all values are saved to sessionStorage
      }
    };
    
    document.addEventListener('visibilitychange', handleVisibilityChange);
    return () => document.removeEventListener('visibilitychange', handleVisibilityChange);
  }, []);

  // Notify user if restored state
  useEffect(() => {
    const hasRestoredState = sessionStorage.getItem(`form_state_${activeSection}_about_me_bio`);
    if (hasRestoredState) {
      toast({
        title: "Form state restored",
        description: "Your unsaved changes have been restored.",
        duration: 3000,
      });
    }
  }, [toast, activeSection]);

  return null; // This component doesn't render anything
};

export default AboutMeAutoSave;
